const SELECTORS = {
  form: 'form[action="/cart/add"]',
  submitButton:
    '.mw-apo-add-to-cart-cloned, form[action="/cart/add"] [name="add"], form[action="/cart/add"] button[type="submit"], form[action="/cart/add"] input[type="submit"], button[name="add"]',
  variantInput: '[name="id"]',
  existingInlineMount: '.mulberry-box',
  inlineContainer: '.mulberry-inline-container',
  priceContainer: '.product-price',
  priceValue: '.price__current',

  customButton: '.mulberry-custom-atc',
  customButtonText: '.mw-text',
  customButtonSpinner: '.mw-apo-spinner'
};
window.log = [];

(() => {
  'use strict';
 

  const state = {
    initialized: false,
    form: null,
    submitButton: null,
    inlineContainer: null,
    product: null,
    offers: [],
    inline: null,
    modal: null,
    selectedInlineWarranty: null,
    currentVariantId: '',
    busy: false,
    variantTimer: null,
    variantWatcher: null,
    originalButton: null,
    customButton: null,
  };

  function applyMulberryLogoRowCss() {
    const settings = window.mulberry?.core?.settings;
    if (!settings) return;
    if (String(settings.selector_custom_css || "").includes(".mb-inline__logo{display:inline-flex")) {
      return;
    }

    settings.selector_custom_css = [
      ".mb-inline__logo{display:inline-flex !important;flex-direction:column !important;align-items:flex-end !important;gap:2px !important;width:max-content !important;max-width:none !important;color:#483B85 !important;white-space:nowrap !important;}",
      ".mb-inline__logo svg{display:inline-block !important;flex:0 0 auto !important;width:55px !important;height:12px !important;}",
      settings.selector_custom_css || ""
    ].join("");
  }

  document.addEventListener("mulberry-shopify:loaded", applyMulberryLogoRowCss, true);

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function ensureCustomButtonStyles() {
    if (
      document.getElementById(
        'mulberry-custom-atc-styles'
      )
    ) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'mulberry-custom-atc-styles';
    style.textContent = `
      .mulberry-custom-atc {
        display: flex;
        justify-content: center;
        align-items: center;
        appearance: none;
        cursor: pointer;
        width: 100%;
        padding: 0 16px;
        min-width: 120px;
        min-height: 44px;
        font-size: 16px;
        color: #fff;
        background-color: #000;
        text-decoration: none;
        border: 2px solid transparent;
        border-radius: 4px;
        margin-top: 16px;
        transition: box-shadow .2s cubic-bezier(0, 0, .42, 1);
      }

      .mulberry-custom-atc:hover:not(:disabled):not(.mw-apo-in-progress),
      .mulberry-custom-atc:active:not(:disabled):not(.mw-apo-in-progress),
      .mulberry-custom-atc:focus:not(:disabled):not(.mw-apo-in-progress) {
        box-shadow: 0 0 0 2px #000;
      }

      .mulberry-custom-atc .mw-apo-spinner {
        display: none;
        width: 20px;
        height: 20px;
      }

      .mulberry-custom-atc.mw-apo-in-progress .mw-apo-spinner {
        display: block;
      }

      .mulberry-custom-atc.mw-apo-in-progress .mw-text {
        display: none !important;
        overflow: hidden !important;
        position: absolute !important;
        left: -9999px !important;
      }

      .mulberry-custom-atc:disabled {
        opacity: 0.7;
        cursor: not-allowed;
      }
    `;

    document.head.appendChild(style);
  }

  function getSettings() {
    return window.mulberry?.core?.settings || {};
  }

  function hasInlineIntegration() {
    return Boolean(getSettings().has_inline) || true;
  }

  function hasModalIntegration() {
    return Boolean(getSettings().has_modal) || true;
  }

  function findProductForm() {
    return (
      document.querySelector(SELECTORS.form)
    );
  }

  function findRealAddToCartButton() {
    const candidateSelectors = [
      'form[action="/cart/add"] [name="add"]',
      'form[action="/cart/add"] button[type="submit"]',
      'form[action="/cart/add"] input[type="submit"]',
      'button[name="add"]',
    ];

    return [...document.querySelectorAll(candidateSelectors.join(', '))].find(
      (button) =>
        !button.matches(
          '.mulberry-custom-atc, .mw-apo-add-to-cart-cloned'
        )
    ) || null;
  }

  function findExistingCustomButton() {
    return (
      document.querySelector(
        '.mulberry-custom-atc'
      ) || null
    );
  }

  function getVariantInput() {
    return state.form?.querySelector(SELECTORS.variantInput) || null;
  }

  function getCurrentVariantId() {
    const formVariantId = getVariantInput()?.value;

    const urlVariantId = new URL(
      window.location.href
    ).searchParams.get('variant');

    return String(formVariantId || urlVariantId || '').trim();
  }

  function getSelectedVariant() {
    const variantId = getCurrentVariantId();

    if (variantId) {
      window.mulberryShop.selectedVariantId = variantId;
    }

    return (
      state.product?.variants?.find(
        (variant) => String(variant.id) === String(variantId)
      ) ||
      state.product?.variants?.[0] ||
      null
    );
  }

  function getObservedProductPrice() {
    const priceContainer = document.querySelector(
      SELECTORS.priceContainer
    );

    if (!priceContainer) {
      return null;
    }

    const rawPriceText =
      priceContainer.querySelector(
        SELECTORS.priceValue
      )?.textContent ||
      priceContainer.textContent ||
      '';

    const normalizedText = rawPriceText
      .replace(/,/g, '')
      .replace(/[^0-9.]/g, '')
      .trim();

    if (!normalizedText) {
      return null;
    }

    const parsed = Number.parseFloat(normalizedText);

    if (Number.isNaN(parsed)) {
      return null;
    }

    return parsed.toFixed(2);
  }

  async function fetchOffersForCurrentVariant() {
    const selectedVariant = getSelectedVariant();

    if (!selectedVariant || !state.product) {
      return [];
    }

    window.mulberryShop.selectedVariantId = String(selectedVariant.id);

    const observedPrice = getObservedProductPrice();
    const offerPrice =
      observedPrice || selectedVariant.price;

    const fetchedOffers =
      await window.mulberry.core.getWarrantyOffer({
        id: selectedVariant.id,
        title: state.product.title,
        price: offerPrice,
        detail: state.product,
      });

    return Array.isArray(fetchedOffers) ? fetchedOffers : [];
  }

  function ensureInlineContainer() {

    let container = document.querySelector(
      SELECTORS.inlineContainer
    );
    if (container) {
      return container;
    }

    container = document.createElement('div');
    container.className =
      SELECTORS.inlineContainer.replace('.', '');

    container.style.minHeight = '100px';

    const existingMount = document.querySelector(
      SELECTORS.existingInlineMount
    );

    if (existingMount) {
      existingMount.appendChild(container);
    } else {
      const target = document.getElementById('mw-apo-app-block');
      window.log.push(target);
      target.insertAdjacentElement('afterend',
        container
      );
    }

    return container;
  }

  function setInlineVisibility(visible) {
    if (!state.inlineContainer) {
      return;
    }

    state.inlineContainer.style.display = visible
      ? ''
      : 'none';

    state.inlineContainer.style.minHeight = visible
      ? ''
      : '0';
  }

  function clearInlineSelection() {
    state.selectedInlineWarranty = null;
    window.selectedOffer = null;

    try {
      state.inline?.deselectOffer?.();
    } catch (error) {
      console.warn(
        'Mulberry inline deselect failed:',
        error
      );
    }

    renderOfferCard();
  }

  function unwrapWarranty(warranty) {
    return warranty?.offer || warranty;
  }

  async function addWarrantyBeforeProduct(warranty) {
    const offer = unwrapWarranty(warranty);

    if (!offer) {
      throw new Error(
        'No Mulberry warranty offer was supplied.'
      );
    }

    const selectedVariant = getSelectedVariant();

    if (!selectedVariant) {
      throw new Error(
        'Unable to identify the selected Shopify variant.'
      );
    }

    window.mulberryShop.selectedVariantId =
      String(selectedVariant.id);

    const warrantyVariant =
      await window.mulberryShop.getWarrantyVariant(offer);

    if (!warrantyVariant?.shopify_variant_id) {
      throw new Error(
        'Mulberry did not return a Shopify warranty variant.'
      );
    }

    await window.mulberryShop.addWarrantyToCart(
      warrantyVariant.shopify_variant_id,
      {
        ...state.product,
        title: state.product.title,
        variantId: String(selectedVariant.id),
      },
      offer
    );
  }

  function setBusy(isBusy) {
    state.busy = isBusy;

    if (!state.customButton) return;

    state.customButton.setAttribute(
      'aria-busy',
      String(isBusy)
    );

    state.customButton.classList.toggle(
      'mulberry-is-processing',
      isBusy
    );

    state.customButton.classList.toggle(
      'mw-apo-in-progress',
      isBusy
    );

    state.customButton.disabled = isBusy;
  }

  function ensureCustomButtonMarkup(button) {
    if (!button) {
      return;
    }

    // button.classList.add('mw-apo-add-to-cart-cloned');
    button.classList.add('mw-apo-add-to-cart-cloned');

    let textEl = button.querySelector(
      SELECTORS.customButtonText
    );

    if (!textEl) {
      textEl = document.createElement('span');
      textEl.className =
        SELECTORS.customButtonText.replace('.', '');

      if (
        button.querySelector('.product-atc-label, .product-atc-price-wrap')
      ) {
        while (button.firstChild) {
          textEl.appendChild(button.firstChild);
        }
      } else {
        textEl.textContent =
          (button.textContent || '').trim() || 'Add to cart';
        button.textContent = '';
      }

      button.appendChild(textEl);
    }

    let spinnerEl = button.querySelector(
      SELECTORS.customButtonSpinner
    );

    if (!spinnerEl) {
      spinnerEl = document.createElement('span');
      spinnerEl.className =
        SELECTORS.customButtonSpinner.replace('.', '');
      spinnerEl.setAttribute('aria-hidden', 'true');
      button.appendChild(spinnerEl);
    }
  }

  async function runBusy(action) {
    if (state.busy) {
      return;
    }

    setBusy(true);

    try {
      await action();
    } finally {
      if (state.busy) {
        setBusy(false);
      }
    }
  }

  function submitOriginalProductForm() {
    if (!state.form) {
      return;
    }

    const originalButton =
      state.originalButton &&
      state.originalButton !== state.customButton
        ? state.originalButton
        : state.submitButton;

    if (
      originalButton &&
      originalButton !== state.customButton
    ) {
      originalButton.disabled = false;
      originalButton.click();
      return;
    }

    if (typeof state.form.requestSubmit === 'function') {
      state.form.requestSubmit();
      return;
    }

    HTMLFormElement.prototype.submit.call(state.form);
  }

  async function addWarrantyThenSubmit(warranty) {
    try {
      await addWarrantyBeforeProduct(warranty);

      clearInlineSelection();

      setBusy(false);

      submitOriginalProductForm();
    } catch (error) {
      console.error(
        'Mulberry warranty could not be added:',
        error
      );

      setBusy(false);

      submitOriginalProductForm();
    }
  }

  async function handleCustomButtonClick(event) {
    event.preventDefault();

    if (state.busy) {
      return;
    }

    if (
      hasInlineIntegration() &&
      state.inline &&
      state.selectedInlineWarranty
    ) {
      await runBusy(async () => {
        await addWarrantyThenSubmit(
          state.selectedInlineWarranty
        );
      });

      return;
    }

    if (
      hasModalIntegration() &&
      state.modal &&
      state.offers.length > 0
    ) {
      // Warranty modal instead of ATC — drop any optimistic spinner.
      state.customButton?.classList.remove('is-loading');
      state.customButton?.removeAttribute('aria-busy');
      state.modal.open();
      return;
    }

    submitOriginalProductForm();
  }

  function setupAtcButtons() {
    ensureCustomButtonStyles();

    const existingMwApoButton = document.querySelector(
      '.mw-apo-add-to-cart-cloned'
    );

    state.originalButton =
      existingMwApoButton ||
      findRealAddToCartButton() ||
      state.submitButton;
    state.customButton =
      findExistingCustomButton() || null;

    if (!state.originalButton) {
      console.warn(
        'Mulberry PDP integration: original Add to Cart button was not found.'
      );
      return;
    }

    if (!state.customButton) {
      const clonedButton =
        state.originalButton.cloneNode(true);

      if (!clonedButton) {
        console.warn(
          'Mulberry PDP integration: custom Add to Cart button could not be created.'
        );
        return;
      }

      clonedButton.classList.add(
        SELECTORS.customButton.replace('.', '')
      );
      clonedButton.classList.remove(
        'mw-apo-add-to-cart-cloned'
      );
      clonedButton.removeAttribute('id');
      clonedButton.disabled = false;
      clonedButton.style.display = '';
      clonedButton.setAttribute('aria-hidden', 'false');
      clonedButton.tabIndex = 0;

      state.originalButton.insertAdjacentElement(
        'afterend',
        clonedButton
      );

      state.customButton = clonedButton;
    }

    ensureCustomButtonMarkup(state.customButton);

    if (
      state.originalButton &&
      state.originalButton !== state.customButton
    ) {
      state.originalButton.style.display = 'none';
      state.originalButton.setAttribute(
        'aria-hidden',
        'true'
      );
      state.originalButton.tabIndex = -1;
    }

    state.customButton.style.display = '';
    state.customButton.setAttribute('type', 'button');
    state.customButton.onclick = handleCustomButtonClick;
  }


  const MULBERRY_LOGO_PATH = "M27.1572 0.875386C27.1572 0.744822 27.2878 0.614258 27.4184 0.614258H29.5727C29.7032 0.614258 29.8338 0.744822 29.8338 0.875386V13.2789C29.8338 13.4095 29.7032 13.5401 29.5727 13.5401H27.4184C27.2878 13.5401 27.1572 13.4095 27.1572 13.2789V0.875386ZM14.4273 8.44808C14.4273 6.09793 12.9911 4.72701 11.0979 4.72701C9.72699 4.72701 8.68248 5.37983 8.02966 6.29378C7.50741 5.31455 6.4629 4.72701 5.35311 4.72701C4.11276 4.72701 3.19881 5.37983 2.67655 6.29378L2.61127 5.18399C2.61127 5.05342 2.48071 4.92286 2.35014 4.92286H0.261127C0.130563 4.92286 0 5.05342 0 5.18399V13.3442C0 13.4748 0.130563 13.6053 0.261127 13.6053H2.41543C2.54599 13.6053 2.67655 13.4748 2.67655 13.3442V8.77449C2.67655 8.31751 3.19881 7.20772 4.37388 7.20772C5.09198 7.20772 5.87536 7.59941 5.87536 9.03561V13.4095C5.87536 13.5401 6.00593 13.6706 6.13649 13.6706H8.29079C8.42136 13.6706 8.55192 13.5401 8.55192 13.4095V8.64392C8.55192 8.12167 9.13945 7.14244 10.2492 7.14244C10.9673 7.14244 11.7507 7.53413 11.7507 8.97033V13.3442C11.7507 13.4748 11.8813 13.6053 12.0119 13.6053H14.1662C14.2967 13.6053 14.4273 13.4748 14.4273 13.3442V8.44808ZM25.0029 5.18399C25.0029 5.05342 24.8724 4.92286 24.7418 4.92286H22.5875C22.4569 4.92286 22.3264 5.05342 22.3264 5.18399V9.819C22.3264 10.4718 21.8041 11.3858 20.6943 11.3858C20.0415 11.3858 19.1276 10.9941 19.1276 9.62315V5.24927C19.1276 5.1187 18.997 4.98814 18.8664 4.98814H16.7121C16.5816 4.98814 16.451 5.1187 16.451 5.24927V10.1454C16.451 12.4956 17.8219 13.8665 19.7804 13.8665C20.8249 13.8665 21.7388 13.2789 22.3264 12.4303L22.3917 13.3442C22.3917 13.4748 22.5222 13.6053 22.6528 13.6053H24.7418C24.8724 13.6053 25.0029 13.4748 25.0029 13.3442V5.18399ZM41.1275 9.29674C41.1275 6.75075 39.3649 4.72701 36.8842 4.72701C35.905 4.72701 35.1216 5.1187 34.5994 5.70624V0.940667C34.5994 0.810103 34.4688 0.67954 34.3382 0.67954H32.1839C32.0534 0.67954 31.9228 0.810103 31.9228 0.940667V13.3442C31.9228 13.4748 32.0534 13.6053 32.1839 13.6053H34.0118C34.1424 13.6053 34.273 13.4748 34.273 13.3442L34.4035 12.6261C34.9258 13.2789 35.7744 13.7359 36.8842 13.7359C39.2997 13.7359 41.1275 11.7122 41.1275 9.29674ZM36.5578 11.2552C37.7329 11.2552 38.5163 10.4065 38.5163 9.23146C38.5163 7.9911 37.6676 7.14244 36.5578 7.14244C35.3827 7.14244 34.5994 8.05639 34.5994 9.23146C34.5994 10.4065 35.3827 11.2552 36.5578 11.2552ZM50.3323 10.1454C50.8545 10.1454 50.9851 9.75371 50.9851 9.03561C50.9851 6.68547 49.3531 4.72701 46.8071 4.72701C44.2611 4.72701 42.3679 6.68547 42.3679 9.23146C42.3679 11.7122 44.2611 13.7359 47.0029 13.7359C48.2433 13.7359 49.4183 13.2137 50.267 12.4303C50.3976 12.2997 50.3976 12.1691 50.3323 12.0386L49.4183 11.1246C49.2878 10.9941 49.1572 10.9941 49.0266 11.0594C48.3738 11.451 47.9169 11.5816 47.3293 11.5816C46.1542 11.5816 45.3709 11.0594 45.1097 10.1454H50.3323ZM46.8071 7.01188C45.8931 7.01188 45.175 7.46885 44.9792 8.51336H48.5697C48.3738 7.53413 47.6557 7.01188 46.8071 7.01188ZM58.7536 5.57568C58.8189 5.44511 58.8189 5.31455 58.6884 5.18399C58.4272 4.92286 57.9703 4.72701 57.448 4.72701C56.4035 4.72701 55.6201 5.37983 55.2284 6.2285L55.1631 5.24927C55.1631 5.1187 55.0326 4.98814 54.902 4.98814H52.8783C52.7477 4.98814 52.6171 5.1187 52.6171 5.24927V13.4095C52.6171 13.5401 52.7477 13.6706 52.8783 13.6706H55.0326C55.1631 13.6706 55.2937 13.5401 55.2937 13.4095V9.1009C55.2937 8.05639 55.9465 7.20772 57.0563 7.20772C57.3174 7.20772 57.5133 7.27301 57.7091 7.33829H57.7744C57.9703 7.40357 58.1661 7.33829 58.2314 7.14244L58.7536 5.57568ZM66.1958 5.18399C66.3263 5.31455 66.3263 5.44511 66.261 5.57568L65.6735 7.07716C65.6082 7.27301 65.4124 7.33829 65.2165 7.273H65.1513C65.0207 7.20772 64.8249 7.14244 64.4984 7.14244C63.3886 7.14244 62.7358 7.92582 62.7358 9.03561V13.3442C62.7358 13.4748 62.6053 13.6053 62.4747 13.6053H60.3204C60.1898 13.6053 60.0593 13.4748 60.0593 13.3442V5.18399C60.0593 5.05342 60.1898 4.92286 60.3204 4.92286H62.3441C62.4747 4.92286 62.6053 5.05342 62.6053 5.18399L62.6705 6.16321C63.1275 5.31455 63.8456 4.66173 64.8901 4.66173C65.4777 4.72701 65.9346 4.92286 66.1958 5.18399ZM76.3145 5.18399C76.3797 4.98814 76.3145 4.85758 76.1186 4.85758H73.899C73.7685 4.85758 73.6379 4.92286 73.5726 5.05342L71.6142 10.4065L69.6557 5.05342C69.5904 4.92286 69.4599 4.85758 69.3293 4.85758H67.175C66.9792 4.85758 66.9139 4.98814 66.9791 5.18399L70.3738 13.6053L69.1335 16.6736C69.0029 16.8694 69.1334 17 69.3293 17H71.4183C71.5489 17 71.6794 16.9347 71.7447 16.8042L76.3145 5.18399Z";

  function offerNode(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function formatPlanPrice(offer) {
    const raw = offer?.customer_cost || offer?.cost || "";
    const amount = Number.parseFloat(String(raw).replace(/,/g, ""));
    if (Number.isNaN(amount)) return "";
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: offer?.currency || "USD",
    });
  }

  function formatPlanTerm(offer) {
    if (offer?.plan_type === "subscription") return "Unlimited";
    const months = Number.parseInt(offer?.duration_months, 10);
    if (!months) return "Plan";
    if (months % 12 === 0) return `${months / 12} Year`;
    return `${months} Month`;
  }

  function hideInlineFrames() {
    if (!state.inlineContainer) return;
    state.inlineContainer.querySelectorAll("iframe").forEach((frame) => {
      frame.setAttribute("aria-hidden", "true");
      frame.tabIndex = -1;
    });
  }

  function selectOfferCard(offer) {
    const currentId = unwrapWarranty(state.selectedInlineWarranty)?.warranty_offer_id;
    if (currentId && currentId === offer.warranty_offer_id) {
      clearInlineSelection();
      return;
    }

    state.selectedInlineWarranty = { offer, isSelected: true };
    window.selectedOffer = state.selectedInlineWarranty;
    if (window.mulberry?.inline) {
      window.mulberry.inline.isSelected = true;
    }
    renderOfferCard();
  }

  function renderOfferCard() {
    if (!state.inlineContainer) return;

    hideInlineFrames();

    const existing = state.inlineContainer.querySelector(".mb-offer-card");
    if (!state.offers.length) {
      existing?.remove();
      return;
    }

    const selectedId = unwrapWarranty(state.selectedInlineWarranty)?.warranty_offer_id || "";
    const card = offerNode("div", "mb-offer-card");

    const header = offerNode("div", "mb-offer-card__header");
    const brand = offerNode("div", "mb-offer-card__brand");
    const shield = offerNode("span", "mb-offer-card__shield");
    shield.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path fill="#2d679d" d="M12 2.2 19.2 5v6.2c0 4.7-2.9 8-7.2 9.3C7.7 19.2 4.8 15.9 4.8 11.2V5L12 2.2Z"/><path fill="#fff" d="M10.3 12.4 8.6 10.7 7.4 11.9l2.9 2.9 5.6-5.6-1.2-1.2-4.4 4.4Z"/></svg>';
    brand.append(
      shield,
      offerNode("p", "mb-offer-card__title", "Protect Your Purchase with Mulberry")
    );

    const logo = offerNode("a", "mb-inline__logo mb-offer-card__logo");
    logo.href = "https://www.getmulberry.com/mulberrycare";
    logo.target = "_blank";
    logo.rel = "noopener noreferrer";
    logo.setAttribute("aria-label", "Powered by Mulberry");
    logo.appendChild(document.createTextNode("Powered by "));
    const logoSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    logoSvg.setAttribute("width", "55");
    logoSvg.setAttribute("height", "12");
    logoSvg.setAttribute("viewBox", "0 0 77 17");
    logoSvg.setAttribute("fill", "none");
    logoSvg.setAttribute("aria-hidden", "true");
    const logoPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    logoPath.setAttribute("fill-rule", "evenodd");
    logoPath.setAttribute("clip-rule", "evenodd");
    logoPath.setAttribute("fill", "#483B85");
    logoPath.setAttribute("d", MULBERRY_LOGO_PATH);
    logoSvg.appendChild(logoPath);
    logo.appendChild(logoSvg);
    const top = offerNode("div", "mb-offer-card__top");
    top.append(brand, logo);
    header.append(
      top,
      offerNode("p", "mb-offer-card__subtitle", "Extended warranty from a trusted protection provider")
    );

    const benefits = offerNode("ul", "mb-offer-card__benefits");
    ["Easy claims online", "Fast replacements", "No fees"].forEach((label) => {
      const item = offerNode("li");
      const icon = offerNode("span", "mb-offer-card__check");
      icon.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#4ca154"/><path d="M4.6 8.1 6.8 10.3 11.4 5.7" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      item.append(icon, document.createTextNode(label));
      benefits.appendChild(item);
    });

    const plans = offerNode("div", "mb-offer-card__plans");
    plans.appendChild(offerNode("p", "mb-offer-card__label", "Select a plan"));
    const options = offerNode("div", "mb-offer-card__options");
    options.setAttribute("role", "group");
    options.setAttribute("aria-label", "Protection plans");

    state.offers.forEach((offer) => {
      const pressed = Boolean(selectedId) && selectedId === offer.warranty_offer_id;
      const button = offerNode("button", "mb-offer-card__option");
      button.type = "button";
      button.setAttribute("aria-pressed", pressed ? "true" : "false");
      const term = formatPlanTerm(offer);
      const price = formatPlanPrice(offer);
      button.setAttribute("aria-label", `${term} protection for ${price}`);
      button.append(
        offerNode("span", "mb-offer-card__term", term),
        offerNode("span", "mb-offer-card__price", price)
      );
      button.addEventListener("click", () => selectOfferCard(offer));
      options.appendChild(button);
    });

    plans.appendChild(options);
    card.append(header, benefits, plans);

    if (existing) existing.replaceWith(card);
    else state.inlineContainer.prepend(card);
  }

  async function initInline() {
    if (!hasInlineIntegration()) {
      return;
    }

    state.inlineContainer = ensureInlineContainer();

    setInlineVisibility(state.offers.length > 0);

    const settings = getSettings();
    applyMulberryLogoRowCss();

    state.inline = await window.mulberry.inline.init({
      offers: state.offers,
      settings: settings,
      selector: SELECTORS.inlineContainer,

      layout: {
        faq: false,
      },

      onWarrantyToggle: async (warranty) => {
        const isSelected = Boolean(
          warranty?.isSelected
        );

        state.selectedInlineWarranty = isSelected
          ? warranty
          : null;

        window.selectedOffer =
          state.selectedInlineWarranty;

        window.mulberry.inline.isSelected =
          isSelected;

        renderOfferCard();
      },
    });

    window.pdpInline = state.inline;
    renderOfferCard();

    // if(state.offers.length > 0){
    //     window.mulberry.faq.init({
    //       coverage: window.mulberry.core.offers[0],
    //       settings: window.mulberry.core.settings
    //     })
    //     document.querySelector("#whats-covered-faq").removeAttribute("style")
    //     document.querySelector("#whats-covered-faq")?.addEventListener("click",function(){
    //       mulberry.faq.open();
    //     });
    // }
  }

  async function initModal() {
    if (!hasModalIntegration()) {
      return;
    }

    state.modal = await window.mulberry.modal.init({
      offers: state.offers,
      settings: getSettings(),

      onWarrantySelect: async (warranty) => {
        state.modal?.close?.();

        await runBusy(async () => {
          await addWarrantyThenSubmit(warranty);
          setTimeout(async()=>{
            await window.mulberryShop.cart.init();
            await window.mulberryShop.cart.render();
          },100)
        });
      },

      onWarrantyDecline: async () => {
        state.modal?.close?.();

        submitOriginalProductForm();
        await removeAndSyncWarranties();
      },
    });

    window.pdpModal = state.modal;
  }

  async function initCart(){
    setTimeout(async()=>{
      await window.mulberryShop.cart.init();
      await window.mulberryShop.cart.render();
      await removeAndSyncWarranties();
    },100)
    document.addEventListener('mulberry-shopify:warranty-added', async () => {      
      await removeAndSyncWarranties();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      var unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, async function () {
        await removeAndSyncWarranties();
      });
    }
  }

//   async function rebuildCard(){
//     if (window.location.href.includes('/cart')) {
//       fetch(`${routes.cart_url}?section_id=main-cart-items`)
//       .then((response) => response.text())
//       .then(async (responseText) => {
//         const html = new DOMParser().parseFromString(
//           responseText,
//           "text/html"
//         );
//         const sourceQty = html.querySelector("cart-items");
//         document.querySelector("cart-items").innerHTML = sourceQty.innerHTML;
//         // this.innerHTML = sourceQty.innerHTML;
//         await window.mulberryShop.cart.init();
//         await window.mulberryShop.cart.render();
//       })
//       .catch((e) => {
//         console.error(e);
//         setTimeout(() => {
//           Rebuy.init();
//         }, 100);
//       });
//     }else{
//       fetch(`${routes.cart_url}?section_id=cart-drawer`)
//       .then((response) => response.text())
//       .then(async (responseText) => {
//         const html = new DOMParser().parseFromString(
//           responseText,
//           "text/html"
//         );
//         const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
//         for (const selector of selectors) {
//           const targetElement = document.querySelector(selector);
//           const sourceElement = html.querySelector(selector);
//           if (targetElement && sourceElement) {
//             targetElement.replaceWith(sourceElement);
//           }
//         }
//         await window.mulberryShop.cart.init();
//         await window.mulberryShop.cart.render();
//         window.mulberryShop.cart.render({ refresh: true });
//         const drawer = document.getElementById("CartDrawer");
//         drawer.querySelector(".drawer__heading>span").innerText = window.syncedQuantitiesCart.item_count;
//       })
//       .catch((e) => {
//         console.error(e);
//       });
//     }
//   }
  async function removeAndSyncWarranties (){
    const cartResponse = await fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
      },
    });

    const cart = await cartResponse.json();
    const detachedWarrantyCart = await window.mulberryShop.removeDetachedWarranty(cart); // Remove Warranties First
    const syncedQuantitiesCart = await window.mulberryShop.cart.syncQuantities(
      detachedWarrantyCart
    ); // Sync Quantities Second
    window.syncedQuantitiesCart = syncedQuantitiesCart;
    // rebuildCard();
  }

  async function refreshOffers(force = false) {
    if (!state.product) {
      return;
    }

    const nextVariantId = getCurrentVariantId();

    if (!nextVariantId) {
      return;
    }

    if (
      !force &&
      nextVariantId === state.currentVariantId
    ) {
      return;
    }

    state.currentVariantId = nextVariantId;

    clearInlineSelection();

    await wait(250);

    state.offers =
      await fetchOffersForCurrentVariant();

    setInlineVisibility(state.offers.length > 0);

    if (state.inline?.updateOffer) {
      state.inline.updateOffer(state.offers);
    }

    if (state.modal?.updateOffer) {
      state.modal.updateOffer(state.offers);
    }

    renderOfferCard();
  }

  function scheduleOfferRefresh(force = false) {
    window.clearTimeout(state.variantTimer);

    state.variantTimer = window.setTimeout(() => {
      refreshOffers(force).catch((error) => {
        console.error(
          'Mulberry variant offer refresh failed:',
          error
        );
      });
    }, 100);
  }
window.changeEvent = []
  function watchVariantChanges() {
    // state.form.addEventListener(
    //   'change',
    //   () => {
    //     window.changeEvent.push("T");
    //     scheduleOfferRefresh(true);
    //   },
    //   true
    // );
    document.querySelectorAll('.mw-option__control').forEach(input => {
      input.addEventListener('change', function () {
        window.selectedVariantIds = [
        ...document.querySelectorAll('.mw-option__control:checked')
        ].map(input =>
          input.closest('.mw-option__value').dataset.mwAddonVariantId
        );
        scheduleOfferRefresh(true);
      });
    });

    let lastSeenVariantId =
      getCurrentVariantId();

    state.variantWatcher = window.setInterval(() => {
      const currentVariantId =
        getCurrentVariantId();

      if (
        currentVariantId &&
        currentVariantId !== lastSeenVariantId
      ) {
        lastSeenVariantId = currentVariantId;

        scheduleOfferRefresh(true);
      }
    }, 300);
  }

  async function initMulberryPdp() {
    if (state.initialized) {
      return;
    }

    if (
      !window.location.pathname.includes('/products/')
    ) {
      return;
    }

    if (
      !window.mulberry?.core ||
      !window.mulberryShop
    ) {
      return;
    }

    state.form = findProductForm();

    state.submitButton =
      document.querySelector('.mw-apo-add-to-cart-cloned') ||
      findRealAddToCartButton() ||
      document.querySelector(
        'form[action="/cart/add"] [name="add"], form[action="/cart/add"] button[type="submit"], form[action="/cart/add"] input[type="submit"], button[name="add"]'
      );

    state.customButton =
      findExistingCustomButton() || null;

    if (!state.form || !state.submitButton) {
      console.warn(
        'Mulberry PDP integration: product form or Add to Cart button was not found.'
      );

      return;
    }

    if (
      !hasInlineIntegration() &&
      !hasModalIntegration()
    ) {
      return;
    }

    state.initialized = true;

    window.mb_gtm_is_disabled = true;

    const response =
      await window.mulberryShop.getProductData(
        window.mulberryShop.getProductUrl()
      );

    state.product = response?.product;

    if (!state.product) {
      window.log.push("Mulberry could not load Shopify product data.")
      throw new Error(
        'Mulberry could not load Shopify product data.'
      );
    }
    window.log.push("cuurent");
    window.log.push("response?.product");
    state.currentVariantId =
      getCurrentVariantId();

    state.offers =
      await fetchOffersForCurrentVariant();

    await initInline();
    await initModal();
    setupAtcButtons();

    watchVariantChanges();
  }


  function boot(){
    window.log.push("inboot");
    window.log.push(window.mulberryShop);
    window.log.push(window.mulberry?.core?.settings);
    document.addEventListener(
    'mulberry-shopify:loaded',
    () => {
      window.log.push("mulberry loaded");
      if(window.mulberryShop && window.mulberry?.core?.settings){
      window.log.push("we are about to go to init pdp")
      initMulberryPdp().catch((error) => {
        window.log.push(error);
        console.error(
          'Mulberry PDP initialization failed:',
          error
        );
      });
      // initCart().catch((error)=> {
      //   console.error("Mulberry cart initialization failed",error)
      // });
    }
    },
    {
      once: true,
    }
  );
  }
  function startBoot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }

  function findAtcButton() {
    return (
      document.querySelector('.mw-apo-add-to-cart-cloned') ||
      findExistingCustomButton() ||
      findRealAddToCartButton()
    );
  }

  const observer = new MutationObserver(() => {
    if (!findAtcButton()) return;
    window.log.push('Button Found now');
    startBoot();
    observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Non-APO PDPs render the theme ATC in the initial HTML (no Mageworx
  // .mw-apo-add-to-cart-cloned), so also try boot immediately / on DOM ready.
  if (findAtcButton()) {
    startBoot();
    observer.disconnect();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (findAtcButton()) {
        startBoot();
        observer.disconnect();
      }
    });
  }
})();
//mw-apo-add-to-cart-cloned mw-apo-in-progress